import trainingsReducer from "./reducers";
export { default as trainingsTypes } from "./types";
export { default as trainingsOperations } from "./operations";
export default trainingsReducer;
